import { IPlayersGroupGames } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface NextGames {
  next_games: { [key: string]: IPlayersGroupGames };
}

const initialState: NextGames = {
  next_games: {},
};

const playersNextGamesSlice = initReducer({
  name: "next-games",
  initialState,
  reducers: {
    setPlayersNextGames: (state: NextGames, action: PayloadAction<IPlayersGroupGames[]>) => {
      action.payload.forEach((game) => {
        state.next_games[game.playerId] = game;
      });
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<NextGames> = {
  key: "next-games",
  storage: AsyncStorage,
};

export const playersNextGamesActions = playersNextGamesSlice.actions;

export default createPersistReducer(persistConfig, playersNextGamesSlice.reducer);
